import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { SEGMENT_BY_SLUG } from "@/lib/segments";
import SegmentRoute from "@/pages/SegmentRoute";

export const Route = createFileRoute("/agente-ia-odontologia")({
  head: () => buildHead({
    title: SEGMENT_BY_SLUG["agente-ia-odontologia"]!.metaTitle,
    description: SEGMENT_BY_SLUG["agente-ia-odontologia"]!.metaDescription,
    path: "/agente-ia-odontologia",
  }),
  component: () => <SegmentRoute slug="agente-ia-odontologia" />,
});
